import PropTypes from 'prop-types';
import React from 'react';

class MoneyInput extends React.Component {
    constructor(props) {
        super(props);

        this.handleChange = this.handleChange.bind(this);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick(event) {
        this.props.onClick(event);
    }

    handleChange(event) {
        this.props.onChange(Number(event.target.value));
    }

    shouldShowPlaceholder() {
        return this.props.value === 0 && this.props.placeholder;
    }

    render() {
        const { placeholder, value } = this.props;

        return (
            <div
                className="money-input"
                data-show-placeholder={this.shouldShowPlaceholder() ? 'true' : 'false'}
            >
                <div className="money-input__currency">$</div>
                <div className="money-input__input">
                    <input
                        type="number"
                        min={0}
                        max={Number.MAX_SAFE_INTEGER}
                        className="input-text input-text--borderless"
                        value={this.shouldShowPlaceholder() ? '' : value}
                        placeholder={placeholder}
                        onChange={this.handleChange}
                        onClick={this.handleClick}
                    />
                </div>
            </div>
        );
    }
}

MoneyInput.propTypes = {
    onClick: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.number,
    placeholder: PropTypes.string,
};

MoneyInput.defaultProps = {
    value: null,
    placeholder: null,
};

export default MoneyInput;
